import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../utils/route-auth';

import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../components/ModalConfirmation';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import { isTenantAgency } from '../../../selectors/index';


import { optionsData, formFields } from './constant';
// import Select from '../../../components/FormElements/Select'

// import "";
import Select from "react-select";

import {
    getIoListAllReportAction,
    deleteIoAction,
    getIoEditIdReportAction,
    addIoReportAction,
    roListAction,
    roListNamesAction
} from '../../../actions';

const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class Ro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advertiserListData: [],
            submited: false,
            form: {},
            touched: {},
            errors: {},
            roListData: [],
            roListNames: [],
            selectedData: {},
            selectedStatus: {},
            selectedRo: {},
            roStatus: [],
            statusData: {},
            roNamesData: {},
            // allRo:{},
            filteredTableData: [],
            confirmationOpen: false,
            confirmationInfo: '',
            roList: [],
            optionsList: optionsData
        };
    }

    async componentDidMount() {
        // console.log(this.props.tenantId);
        let istenantAgency = isTenantAgency(this.props.tenantId);
        // console.log("isTenantAgency",istenantAgency)
        this.setState({ istenantAgency: istenantAgency });
      }

    async componentWillMount() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));

        let optionsList = checkTablePermission({ add: PERMISSION.RO.RO.ADD, edit: PERMISSION.RO.RO.EDIT }, cloneDeep(optionsData));

        // console.log(this.props.tenantId);
        // let istenantAgency = isTenantAgency(this.props.tenantId);
        // console.log("isTenantAgency",istenantAgency)
        // this.setState({ istenantAgency: istenantAgency });

        this.setState({ optionsList });

        const { history } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }
        const roStatus = [
            {
                statusID: 0,
                label: "All",
                value: "All Status",
                name: "status"

            },
            {
                statusID: 0,
                label: "Active",
                name: "status",
                value: "Active"
            },
            {
                statusID: 0,
                label: "Inactive",
                value: "Inactive",
                name: "status"

            }
        ]



        let selectedStatus = {
            statusID: 0,
            label: "All",
            value: "All Status"
        }

        let selectedRO = {
            label: "All",
            value: "All RO"
        }

        this.setState({
            roStatus: roStatus, selectedStatus: selectedStatus, selectedRo: selectedRO
        })
        await this.listRO();
        await this.listRoNames();
    }

    getIoListAll() {
        const { getIoListAllReportAction, tenantId, authToken, userId } = this.props;
    }

    handleAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'edit') {
            this.handleEdit(row, match, history);
        } else if (action.type === 'delete') {
            this.handleDelete(row, action);
        } else if (action.key === 'rec_active') {
            this.handleStatus(row);
        }
    };

    async handleStatus({ insertionOrderId = '' }) {
        const { tenantId, authToken, userId, getIoEditIdReportAction, addIoReportAction } = this.props;
        if (insertionOrderId) {
            const { responseCode: { status }, responseList } = await getIoEditIdReportAction(tenantId, authToken, userId, { list: insertionOrderId });
            if (status === "Success") {
                responseList.rec_active = responseList.rec_active ? 0 : 1;
                this.handleStatusUpdate(insertionOrderId, responseList, tenantId, authToken, userId, addIoReportAction);
            }
        } else {
            console.log('insertionOrderId empty');
        }
    }

    async handleStatusUpdate(insertionOrderId, payload, tenantId, authToken, userId, addIoReportAction) {
        const { desc = '', status = '' } = await (addIoReportAction(tenantId, authToken, userId, payload, { addup: insertionOrderId }) || '');
        if (status === 'Success') {
            this.getIoListAll();
            return;
        } else {
            const info = { action: { confirmationMessage: desc, type: 'error' } };
            this.toggleModal(info);
        }
    }

    handleEdit(row, match, history) {
        history.push(`${match.path}/${routes.ro.editRo}/${row.id}`);
    }

    async handleDelete(row) {
        const { deleteIoAction, tenantId, authToken, userId } = this.props;
        let response = await deleteIoAction(tenantId, authToken, userId, { delio: row.insertionOrderId });
        if (response.status === 'Success') {
            this.getIoListAll();
            return;
        }
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };

    // ============ list RO api ===================
    listRO = async () => {
        const { tenantId, authToken, userId, roListAction } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await roListAction({ tenantId, authToken, userId });
        if (status === "Success") {
            this.setState({ roListData: responseList });
            this.setState({ roList: responseList })
        }
    }

    listRoNames = async () => {
        const { tenantId, authToken, userId, roListNamesAction } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await roListNamesAction({ tenantId, authToken, userId });
        if (status === "Success") {
            const roList = responseList.map((item, index) => {
                return { label: item.name, value: item.name, name: "ro" };
            });
            let obj = {
                label: 'All',
                value: "All RO",
                name: "ro"
            }
            roList.unshift(obj)
            this.setState({ roListNames: roList })

            // test
            const { roListData, roStatus } = this.state;
            const inititalList = obj;
            const inititalStatus = roStatus[0];

            if (inititalList.value === "All RO" && inititalStatus.value === "All Status") {
                this.setState({ filteredTableData: roListData })
                let status = 2
                this.setState({ statusData: status })
                this.setState({ roNamesData: inititalList })
            }
        }
    }

    handleRoChange = (selected) => {
        const { roListNames, roStatus } = this.state;
        this.setState({ selectedData: selected })

        if (selected.name == "ro") {
            this.setState({ selectedRo: selected })
        } else {
            this.setState({ selectedStatus: selected })
        }

        if (selected.statusID === 0) {
            let status = selected.value === "Active" ? 1 : selected.value === "Inactive" ? 0 : 2
            this.setState({ statusData: status })
        } else {
            this.setState({ roNamesData: selected })
        }
    }

    handleApply = (e) => {
        e.preventDefault();
        const { roNamesData, statusData, roListData, roList, allRo, selectedRo, selectedStatus } = this.state;

        const newData = roListData.filter(roData => {
            return roData.name === roNamesData.value && roData.status === statusData
        })

        this.setState({ filteredTableData: newData });

        if (roNamesData.value === "All RO") {
            const newData = roListData.filter(roData => {
                return roData.status === statusData
            })

            this.setState({ filteredTableData: newData });
        }

        if (statusData === 2) {
            this.setState({ filteredTableData: roListData });
        }

        if (statusData === 2 && roNamesData.value != "All RO") {
            const filterNewRo = roListData.filter(roData => {
                return roData.name === roNamesData.value
            })
            this.setState({ filteredTableData: filterNewRo });
        }
    }

    handleReset = async (e) => {
        e.preventDefault();
        const { roList } = this.state;
        this.setState({
            filteredTableData: roList, selectedRo: { label: "All", value: "All RO", name: "ro" }, selectedStatus: {
                statusID: 0,
                label: "All",
                value: "All Status",
                name: "status"
            }
        })
    }

    render() {
        const { match, ioListAll, configurationList } = this.props;
        const { confirmationOpen, confirmationInfo, optionsList, filteredTableData, submited, touched, errors, form, roListData, roListNames, selectedData, roStatus, selectedStatus, selectedRo,istenantAgency } = this.state;

        const inititalList = roListNames[0] != undefined ? roListNames[0] : "";
        const inititalStatus = roStatus[0] != undefined ? roStatus[0] : "";

        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3 parentDiv">
                            <Card>
                                {
                                    (checkAddPermission(PERMISSION.RO.RO.ADD)) &&  (
                                        !istenantAgency &&
                                        <div className="margin-list-adj">
                                            <Link to={`${match.path}/${routes.ro.addRo}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>RO</button></Link>
                                        </div>
                                    )
                                }

                            <div class="accordion mt-4" id="accordionWithIcon">
                            <div class="accordion-item card">
                            <h2 class="accordion-header d-flex align-items-center">
                                <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-2" aria-expanded="true">
                                <i class="me-2 ti ti-filter ti-xs"></i>
                                Filter RO
                                </button>
                            </h2>
                            <div id="accordionWithIcon-2" class="accordion-collapse collapse show" >
                                <div class="accordion-body pb-3">
                                {/* <div className="row">
                                    <div className="col-md-12 grid-margin mb-0"> */}
                                        <div className="row">
                                            <div className="col-md-12 px-0  ">
                                                <form className="form-inline d-flex align-items-center" id="filterform" style={{ display: 'block', "border-radius": '5px' }}>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">RO:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roListNames}
                                                                defaultValue={selectedRo}
                                                                value={selectedRo}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">Status:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roStatus}
                                                                defaultValue={selectedStatus}
                                                                value={selectedStatus}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex justify-content-between justify-content-md-start mt-4">
                                                        <button onClick={(e) => this.handleApply(e)} className="btn btn-primary"><i className='mdi mdi-account-check'></i>Apply</button>
                                                        <button onClick={(e) => this.handleReset(e)} className="btn btn-primary ml-3"><i class="mdi mdi-replay"></i>Reset</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    {/* </div>
                                </div> */}
                                </div>
                            </div>
                            </div>
                            </div>

                                {/* <div className="row">
                                    <div className="col-md-12 grid-margin mb-0">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <form className="form-inline d-flex align-items-center" id="filterform" style={{ display: 'block', "border-radius": '5px' }}>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">RO:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roListNames}
                                                                defaultValue={selectedRo}
                                                                value={selectedRo}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">Status:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roStatus}
                                                                defaultValue={selectedStatus}
                                                                value={selectedStatus}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex justify-content-between justify-content-md-start mt-4">
                                                        <button onClick={(e) => this.handleApply(e)} className="btn btn-primary"><i className='mdi mdi-account-check'></i>Apply</button>
                                                        <button onClick={(e) => this.handleReset(e)} className="btn btn-primary ml-3"><i class="mdi mdi-replay"></i>Reset</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                            {/* </Card>

                            <Card> */}
                                <div className="table-responsive mt-5">
                                    <Table
                                        options={optionsList}
                                        data={filteredTableData}
                                        handelAction={this.handleAction}
                                        hideActionColumn={istenantAgency}
                                    />
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getIoListAllReportAction,
        deleteIoAction,
        getIoEditIdReportAction,
        addIoReportAction,
        roListAction,
        roListNamesAction
    }
)(Ro));

// ----*  IO propTypes * ----
Ro.propTypes = {
    configurationList: PropTypes.array,
    ioListAll: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getIoListAllReportAction: PropTypes.func,
    deleteIoAction: PropTypes.func,
};